import { Timestamp } from "firebase/firestore";

/**
 * Helper function to get the current timestamp.
 * @returns {Timestamp} - The current Firestore timestamp.
 */
export const getCurrentTimestamp = () => {
    return Timestamp.now();
};

/**
 * Helper function to calculate the end date (1 year from now at 11:59 PM).
 * @returns {Timestamp} - The Firestore timestamp for the end date.
 */
export const getEndDateTimestamp = () => {
    const now = new Date();
    const nextYear = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate(), 23, 59, 59);
    return Timestamp.fromDate(nextYear);
};

//Returns formatted date as Mon, Dec 00 YYYY
export const formatDate = (timestamp) => {
    // Check if the timestamp is valid and convert it to a date string
    if (timestamp && timestamp.toDate) {
        return timestamp.toDate().toLocaleDateString("en-US", {
            weekday: 'short', month: 'short', day: 'numeric', year: 'numeric'
        });
    }
    return "N/A"; // Return "N/A" if timestamp is not available
};

//Returns formatted time as 00:00 PM
export const formatTime = (timestamp) => {
    // Check if the timestamp is valid and convert it to a time string with AM/PM
    if (timestamp && timestamp.toDate) {
        return timestamp.toDate().toLocaleTimeString("en-US", {
            hour: '2-digit', 
            minute: '2-digit', 
            hour12: true,
        });
    }
    return "N/A"; // Return "N/A" if timestamp is not available
};

/**
 * Format a date object as "December 28 2024 HH:MM:SS AM"
 * @param {Date} date - The date object to format
 * @returns {string} - The formatted date string
 */
export const formatLongDateTime = (date) => {
    const options = { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric', 
        hour: '2-digit', 
        minute: '2-digit', 
        second: '2-digit', 
        hour12: true 
    };
    return new Intl.DateTimeFormat('en-US', options).format(date);
};

//Calculates remaiing days from a start and end date
export const calculateDaysUntilExpiration = (endDate) => {
    if (endDate) {
        const currentDate = new Date();
        const end = endDate.toDate();      // Convert to Date object
        
        // Calculate the difference in days between current date and the end date
        const timeDiff = end - currentDate;  // Time difference in milliseconds
        const daysRemaining = Math.ceil(timeDiff / (1000 * 3600 * 24));  // Convert milliseconds to days
        
        return daysRemaining - 1;  // Return the number of days remaining
    }
    
    return null; // Return null if startDate or endDate is not provided
};